// It's easier to do some small DOM manipulation in JS
// rather than eject Formie templates from the standard

$(".fui-select").each(function() {
  $(this).wrap("<div class='custom-select'></div>");
})
